var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavoriteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8361 5.5868L10.0548 5.00656L8.36022 1.41147C8.23583 1.14931 7.98587 1 7.71831 1C7.45075 1 7.20079 1.16878 7.0764 1.41147L5.38185 5.00656L1.60056 5.5868C1.333 5.62376 1.10087 5.83074 1.03024 6.0919C0.95865 6.35431 1.01264 6.65367 1.20861 6.85965L3.95581 9.66851L3.31366 13.6194C3.25991 13.9003 3.38525 14.1812 3.59906 14.3499C3.81263 14.5185 4.11635 14.5372 4.34776 14.4064L7.73686 12.5338L11.126 14.4064C11.2328 14.463 11.3395 14.5 11.4651 14.5C11.6081 14.5 11.7679 14.4436 11.8935 14.3499C12.107 14.1812 12.2148 13.9003 12.1786 13.6194L11.5367 9.66851L14.2837 6.85965C14.4799 6.65367 14.5512 6.35431 14.462 6.0919C14.3172 5.81101 14.1036 5.62376 13.8361 5.5868Z",
    stroke: "#4F4F4F",
    strokeWidth: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteIcon);
export default __webpack_public_path__ + "static/media/favorite-icon.0c6fa20b00d5580a60791da9a0ff0c39.svg";
export { ForwardRef as ReactComponent };